export class MessagingConstants {
    public static DISPLAYTYPE_INPAGE = 'inpage';
    public static DISPLAYTYPE_MODAL = 'modal';
    public static MESSAGETYPE_INFO = 'info';
    public static MESSAGETYPE_CONFIRM = 'confirm';
    public static MESSAGETYPE_WARN = 'warn';
    public static MESSAGETYPE_ERROR = 'error';
    public static MESSAGETYPE_TIP = 'tip';
    public static MODAL_WIDTH = '350px';
    public static MESSAGE_COLOR_CONFIRM = 'positive';
    public static MESSAGE_COLOR_INFO = 'information';
    public static MESSAGE_COLOR_WARNING = 'warning';
    public static MESSAGE_COLOR_ERROR = 'negative';
    public static MESSAGETYPE_COLOR_TIP = 'information';
    public static CONFIRM_MESSAGE_ICON = 'fa-check-circle';
    public static INFO_MESSAGE_ICON = 'fa-info-circle';
    public static WARNING_MESSAGE_ICON = 'fa-exclamation-triangle';
    public static ERROR_MESSAGE_ICON = 'fa-exclamation-circle';
    public static ACTION_BUTTON_LABEL = 'OK';
    public static TIP_MESSAGE_ICON = 'fa-lightbulb';

    // Overlay
    public static PERSHING_OVERLAY_CONFIG = 'pershing-overlay-configuration';
    public static OVERLAY_LOADING_EVENT = 'overlay-loading-event';
    public static OVERLAY_LOADING_COMPLETE_EVENT = 'overlay-loading-complete-event';
}
